import { Flex } from '@mantine/core';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { InvestmentProgrammeDocumentDetailsRes } from '@dealstack/shared/lib/generated';
import type {
	PendingDocumentAction,
	PendingSignerAssignmentAction,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/usePendingDocumentAction.types';
import { SignersTabContent } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/SignersTabContent';
import type { SigningHeaderContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/components/SignersTab.types';

interface Props {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
	documentDetails?: InvestmentProgrammeDocumentDetailsRes;
	isLoading?: boolean;
	isActionPending: boolean;
	beginPendingAction: (action: PendingDocumentAction) => void;
	clearPendingAction: () => void;
	refetchDocument: () => void;
	pendingSignerAssignmentAction: PendingSignerAssignmentAction | null;
	onSigningHeaderChange?: (header: SigningHeaderContext | null) => void;
	onDateApplied: () => void;
}

export const SignersTab = ({
	dealId,
	programmeId,
	documentWorkflowInstanceId,
	documentDetails,
	isLoading,
	isActionPending,
	beginPendingAction,
	clearPendingAction,
	refetchDocument,
	pendingSignerAssignmentAction,
	onSigningHeaderChange,
	onDateApplied,
}: Props) => {
	if (isLoading || !documentDetails) {
		return (
			<Flex
				w="100%"
				h="100%"
				align="center"
				justify="center"
				style={{ position: 'relative', minHeight: '50vh' }}
			>
				<InlineLoader />
			</Flex>
		);
	}

	return (
		<SignersTabContent
			dealId={dealId}
			programmeId={programmeId}
			documentWorkflowInstanceId={documentWorkflowInstanceId}
			documentDetails={documentDetails}
			isActionPending={isActionPending}
			beginPendingAction={beginPendingAction}
			clearPendingAction={clearPendingAction}
			refetchDocument={refetchDocument}
			pendingSignerAssignmentAction={pendingSignerAssignmentAction}
			onSigningHeaderChange={onSigningHeaderChange}
			onDateApplied={onDateApplied}
		/>
	);
};
